import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, tap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { TwoStepDepositDataService } from './two-step-deposit-data.service';
import { EventEmitterService } from '@core/services/event-emitter.service';
import { ApiResponse } from '@shared/models/api-response.model';

@Injectable({
  providedIn: 'root',
})
export class PortalDepositHttpService {

    messages$ = new Subject<any[]>();
    isSuccess: boolean;

    constructor(
      private http: HttpClient,
      private twoStepDepositDataService: TwoStepDepositDataService,
      private eventEmitterService: EventEmitterService
    ) {}

    add(memberBankAccount: any){
      return this.http.post<ApiResponse>(`/deposit`, memberBankAccount).pipe(
        tap(res => {
          this.isSuccess = res.success;

          const twoStepPGs = this.twoStepDepositDataService.getTwoStepDepositPGs();

          // skip showing success message for two step PGs
          if (this.isSuccess && twoStepPGs.includes(memberBankAccount.payment_gateway_code)) {
            return;
          }

          this.messages$.next(res.message);
        }),
        map(res => res)
      );
    }

    getLimit(pageParam: string){
      return this.http.get<ApiResponse>(`/deposit/limit${pageParam}`).pipe(
        map(res => res.data.rows)
      );
    }

    checkRequirement(){
      return this.http.post<ApiResponse>(`/deposit/check-requirement`, null).pipe(
       tap(res => {
          this.isSuccess = res.success;
          // this.messages1$.next(res.message);
        }),
        map(res => res)
      );
    }

    getTopDepositorList(pageParam: string) {
      return this.http.get<ApiResponse>(`/deposit/topdepositorlist?${pageParam}`).pipe(
        map(res => res.data.rows)
      );
    }

    getCryptoInfo(pageParam: any) {
      return this.http.get<ApiResponse>(`/deposit/crypto${pageParam}`).pipe(
        map(res => res)
      );
    }
    
    cancelDeposit(depositId: number) {
      return this.http.put<ApiResponse>(`/deposit/reject/${depositId}`, {}).pipe(
        map(res => res)
      );
    }

    stepTwoUpdateDeposit(depositId: number, data: any) {
      return this.http.put<ApiResponse>(`/deposit/steptwo/${depositId}`, data).pipe(
        map(res => res)
      );
    }

    changeDepositToExpired(depositId: number) {
      return this.http.put<ApiResponse>(`/deposit/expired/${depositId}`, {}).pipe(
        map(res => res)
      );
    }
    
    downloadQRCode(url: string) {
      const ext = url.split('.').pop();
      const ts = new Date().getTime();
      url = '//' + url.replace(/^https?\:\/\//i, "");

      let header = new HttpHeaders({ 'Cache-Control': 'no-cache' });

      this.http.get('//' + url, { headers: header, responseType: 'blob' }).subscribe(blob => {
        // Create a link element
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `${ts}.${ext}`; // Set the download filename
  
        // Append link to the body, click it, and then remove it
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }, error => {
        console.error('Error downloading the image: ', error);
      });
    }

    checkStepTwoDeposit(id: number) {
      return this.http.get<ApiResponse>(`/deposit/steptwo/${id}`).pipe(
        map(res => res.data.rows)
      );
    }
}
